import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import logo from "../../images/logo.png";
import { IconMenu, IconClose, IconArrowRight } from "../../components/Icons";

const menuItems = [
  { id: "home", name: "Home", linkName: "" },
  { id: "aboutus", name: "About", linkName: "about-us" },
  { id: "medicine", name: "Medicines", linkName: "medicine" },
  { id: "therapeutic-areas", name: "Therapies", linkName: "therapeutic-areas" },
  { id: "distribution", name: "Distributors", linkName: "distribution" },
  { id: "quality", name: "Quality", linkName: "quality" },
  { id: "blogs", name: "Blog", linkName: "blogs" },
  { id: "contact", name: "Contact", linkName: "contact-us" },
];

const isItemActive = (pathname, linkName) => {
  if (linkName === "") return pathname === "/";
  if (linkName === "blogs") return pathname.startsWith("/blog"); // covers /blogs and /blog/:slug
  return pathname === `/${linkName}` || pathname.startsWith(`/${linkName}/`);
};

const Header = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [stuck, setStuck] = useState(false);

  useEffect(() => {
    const onScroll = () => setStuck(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [isMenuOpen]);

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);
  const handleMenuLinkClick = () => {
    if (window.innerWidth <= 991) setIsMenuOpen(false);
  };

  return (
    <header className={`header header-transparent rs-nav ${stuck ? "is-stuck" : ""}`}>
      <div className={`sticky-header navbar-expand-lg ${stuck ? "stuck" : ""}`}>
        <div className="menu-bar clearfix">
          <div className="container-fluid clearfix">
            <div className="menu-logo logo-dark">
              <Link to="/" aria-label="Clametis Pharma — Home">
                <img
                  src={logo}
                  alt="Clametis Pharma"
                  width="140"
                  height="40"
                />
              </Link>
            </div>

            <button
              className={`navbar-toggler collapsed menuicon justify-content-end ${isMenuOpen ? "open" : ""}`}
              type="button"
              onClick={toggleMenu}
              aria-label={isMenuOpen ? "Close navigation" : "Open navigation"}
              aria-expanded={isMenuOpen}
              aria-controls="menuDropdown"
              style={{
                width: 44,
                height: 44,
                borderRadius: 12,
                background: "var(--surface)",
                border: "1px solid var(--ink-200)",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                color: "var(--ink-900)",
                boxShadow: "var(--shadow-xs)",
              }}
            >
              {isMenuOpen ? <IconClose /> : <IconMenu />}
            </button>

            <div className="secondary-menu">
              <ul>
                <li className="btn-area d-none d-lg-block">
                  <Link to="/become-a-distributor" className="btn btn-secondary">
                    Become a distributor
                    <IconArrowRight className="arrow-i" width="16" height="16" />
                  </Link>
                </li>
              </ul>
            </div>

            <div
              className={`menu-links navbar-collapse collapse justify-content-end ${isMenuOpen ? "show" : ""}`}
              id="menuDropdown"
            >
              <div className="menu-logo">
                <Link to="/">
                  <img src={logo} alt="Clametis Pharma" width="140" height="40" />
                </Link>
              </div>

              <ul className="nav navbar-nav">
                {menuItems.map((item) => {
                  const active = isItemActive(location.pathname, item.linkName);
                  return (
                    <li key={item.id} className={active ? "active" : ""}>
                      <Link
                        to={`/${item.linkName}`}
                        onClick={handleMenuLinkClick}
                        aria-current={active ? "page" : undefined}
                      >
                        {item.name}
                      </Link>
                    </li>
                  );
                })}
              </ul>

              <div className="menu-close" onClick={() => setIsMenuOpen(false)} role="button" aria-label="Close menu">
                <IconClose />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
